






























































import { Component, Vue, Prop } from 'vue-property-decorator'
import Search from '@/app/ui/components/Search/index'
import ModalDeleteAll from '@/app/ui/components/ModalDeleteAll/index.vue'
import ModalAdd from './ModalAdd.vue'
import { BulletinModule } from '@/app/store/modules/bulletin'

@Component({
  components: {
    search: Search,
    'modal-delete-all': ModalDeleteAll,
    'modal-add': ModalAdd,
  },
})
export default class extends Vue {
  @Prop({}) public selected
  @Prop({}) public funcSearch
  @Prop({}) public isDisabled
  @Prop({}) public imageDataCategory
  @Prop({}) public clearRowSelected
  @Prop({}) public imageLoading

  // Property Button Delete All
  public modalDelete = {
    id: 'modal-deletes',
  }
  public funcDelete(item, index, button) {
    this.$root.$emit('bv::show::modal', this.modalDelete.id, button)
  }
  public funcOke(item, index, button) {
    const ids = this.selected.map((i) => i.id)
    BulletinModule.deleteBulletin({ ids })
    this.$root.$emit('bv::hide::modal', this.modalDelete.id, button)
    this.clearRowSelected()
  }
}
